import push from "assets/images/push.png";
import couple from "assets/images/couple.jpg";
import shopping from "assets/images/back_shopping.jpg";

export interface IHeroSections {}

export default class HeroSections implements IHeroSections {
  constructor(obj: IHeroSections) {
    Object.assign(this, obj);
  }

  static data = [
    {
      _id: 0,
      hasBgImg: false,
      hasPaper: true,
      headline: "Notifica i tuoi clienti quando crei le tue promozioni",
      description:
        "Adhesion sfrutta la tecnologia delle notifiche push per avvisare i tuoi clienti e offrire loro sconti e agevolazioni",
      img: push,
      isCut: true,
      alt: "mockup",
      imgStart: "start",
    },
    {
      _id: 1,
      hasBgImg: true,
      hasPaper: false,
      headline: "Raddoppia le vendite gi\u00E0 dal primo mese di utilizzo",
      description:
        "Adhesion \u00E8 un'app nativa in abbonamento senza vincoli di tempo adatta ad ogni tipo di attivit\u00E0 commerciale",
      img: couple,
      isCut: false,
      alt: "couple",
      imgStart: "",
    },
    {
      _id: 2,
      hasBgImg: false,
      hasPaper: false,
      headline: "Parti col piede giusto",
      description:
        "Adhesion è in super promozionale iniziale e totalmente gratuito, ma non lo sarà per sempre! Registrandoti ora diventerai un affiliato gratuito per sempre!",
      img: shopping,
      isCut: false,
      alt: "shopping",
      imgStart: "start",
    },
  ];
}
